module.exports = __webpack_public_path__ + "static/media/20a-04.2f85ad95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/20a/20a-04.jpg
// module id = 245
// module chunks = 0